import { render, staticRenderFns } from "./bulma_conversion.vue?vue&type=template&id=628eebfd&lang=html"
import script from "./bulma_conversion.vue?vue&type=script&lang=js"
export * from "./bulma_conversion.vue?vue&type=script&lang=js"
import style0 from "./bulma_conversion.vue?vue&type=style&index=0&id=628eebfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports